import React, { useState, useEffect, useMemo } from 'react'
import { Modal, Form, Button, Select, Input, DatePicker, message, Switch } from 'antd'
import * as API from '../../../../api'
import useChannels from '../../../../hooks/useChannel'

export interface ChannelType {
	id: number;
	channel_name: string;
	[propName: string]: any;
}

export interface HandleDistributionProps {
	contentId: string; // 内容id
	visible?: boolean;
	handleVisible?: (val: boolean) => void;
	onDistribute?: () => void; // 立即下发回调
}

const formLayout = {
	labelCol: { span: 8 },
	wrapperCol: { span: 12 },
}
const smallLayout = {
	labelCol: { span: 8 },
	wrapperCol: { span: 7 },
}

// 默认为艺龙顶楼
const DEFAULT_CHANNEL_TYPE = 3

const HandleDistribution: React.FC<HandleDistributionProps> = ({
	contentId,
	visible,
	handleVisible,
	onDistribute,
}) => {
	const [channelList] = useChannels({ page_no: 1, page_size: 99999999 })
	const [distributeLoading, setDistributeLoading] = useState<boolean>(false)
	// const [overrightVisible, setOverrightVisible] = useState<boolean>(false)
	const [form] = Form.useForm()

	const [channelType, setChannelType] = useState(DEFAULT_CHANNEL_TYPE)
	const [channelOptions, setChannelOptions] = useState([])

	useEffect(() => {
		setChannelOptions(channelList
			.filter(item => item.channel_type == channelType)
			.map(item => <Select.Option key={item.id} value={item.id}>{item.channel_name}</Select.Option>))
		form.setFieldsValue({
			channel_id: null
		})

	}, [channelList, channelType])
	useEffect(() => {
		// if(visible) {
		// 	API.checkPublishDl({contentId, channelId: channelType}).then(res => {
		// 		if(res.code === 0) {
		// 			setOverrightVisible(res.data)
		// 		}
		// 	})
		// }
	}, [channelType, visible])

	useEffect(() => {
		if (!visible) {
			form.resetFields()
			setChannelType(DEFAULT_CHANNEL_TYPE)
		} else {
			// API.checkPublishDl({contentId, channelId})
		}
	}, [visible])

	const handleModalVisible = (val: boolean) => {
		handleVisible(val)
	}

	const handleConfirm = () => {
		handleModalVisible(false)
	}

	const handleCancel = () => {
		handleModalVisible(false)
	}

	/**
	 * 内容 立即下发
	 */
	const handleDistribute = async () => {
		try {
			const fieldsValue = await form.validateFields()
			const params = {
				...fieldsValue,
				content_id: contentId,
			}
			setDistributeLoading(true)
			const { code, data, msg } = await API.addIssue(params)
			setDistributeLoading(false)
			onDistribute && onDistribute() // 无论下发成功或失败都要回调（重新或许列表下发状态）
			if (code === 0) {
				message.success('下发成功！')
				handleModalVisible(false)
			} else if (code === 100121) {
				// 艺龙顶楼 异步下发 提示操作成功信息
				message.success(msg)
				handleModalVisible(false)
			} else {
				message.error(msg)
			}
		} catch (error) {
			setDistributeLoading(false)
		}
	}

	return (
		<Modal
			title="新建渠道"
			visible={visible}
			onOk={handleConfirm}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>取消</Button>,
				<Button key="distribute" type="primary" loading={distributeLoading} onClick={handleDistribute}>立即下发</Button>,
				// <Button key="confirm" type="primary" onClick={handleConfirm}>确定</Button>
			]}
			maskClosable={false}
			centered
		>
			<Form
				{...formLayout}
				colon={false}
				form={form}
				initialValues={{
					channel_type: DEFAULT_CHANNEL_TYPE,
				}}
			>
				<Form.Item label="下发渠道类型" name="channel_type" {...smallLayout}
					rules={[{ required: true, message: '请选择下发渠道类型' }]}
				>
					<Select onChange={setChannelType}>
						<Select.Option value={3}>艺龙顶楼</Select.Option>
						<Select.Option value={1}>公众号</Select.Option>
					</Select>
				</Form.Item>

				<Form.Item shouldUpdate label="下发渠道名称" name="channel_id"
					rules={[{ required: true, message: '请选择下发渠道' }]}
				>
					<Select
						showSearch
						placeholder="请选择下发渠道"
						filterOption={(input, option) =>
							option.children.indexOf(input) >= 0
						}
					>
						{channelOptions}
					</Select>
				</Form.Item>
				{/* {overrightVisible &&
					<Form.Item label="是否覆盖当前商品信息" name="overright" valuePropName="checked" {...smallLayout}
						rules={[{ required: true, message: '请选择下发渠道类型' }]}
					>
						<Switch/>
					</Form.Item>
				} */}
				{/* <Form.Item label="自动下发时间">
					<DatePicker.RangePicker />
				</Form.Item> */}
			</Form>
		</Modal>
	)
}

export default HandleDistribution